/**
 * CreateProjectModal
 *
 * Vulnerability Management project-creation modal — uses the shared
 * FormModal primitive so the chrome (overlay, header, escape /
 * backdrop close, focus trap, error rendering, submit lifecycle)
 * matches the Athena dashboard's Create New Project modal verbatim.
 *
 * The previous version was a 130-line bespoke modal that re-implemented
 * every one of those concerns + borrowed styling from
 * `NewAnalysis.module.css`. Replaced by a single FormModal consumer
 * with one declarative field — the projectName text input.
 */
import React from 'react';
import FormModal from '../../components/ui/FormModal/FormModal';
import { useVulnerabilityManagement } from '../../contexts/VulnerabilityManagementContext';

const FIELDS = [
  {
    name: 'projectName',
    type: 'text',
    label: 'Project Name',
    placeholder: 'e.g., Vehicle Gateway ECU',
    required: true,
    autoFocus: true,
    maxLength: 255,
    helpText: 'Must be unique within your organization',
    validate: (value) =>
      (value || '').trim().length === 0 ? 'Project name is required' : null,
  },
];

const CreateProjectModal = ({ onClose, onCreated }) => {
  const { createProject } = useVulnerabilityManagement();

  return (
    <FormModal
      title="Create Project"
      fields={FIELDS}
      submitLabel="Create Project"
      submittingLabel="Creating..."
      maxWidth={560}
      onSubmit={async (values) => {
        await createProject(values.projectName.trim());
        if (onCreated) onCreated();
      }}
      onClose={onClose}
    />
  );
};

export default CreateProjectModal;
